import React from 'react';

import Header from '../header/header';
import Footer from '../footer/footer';
import PhotoStory from '../photostory/photostory';
import './index.css';
import indexMobPng1 from './index-mob-1.png';
import indexMobPng2 from './index-mob-2.png';
import indexMobPng3 from './index-mob-3.png';
import fundPng from './fund.png';
import Cards from '../cards/cards';
import Button from '../button/button';
import Anchor from '../anchor/anchor';

class Index extends React.Component {
    render() {
        return (
            <div className="index">
                {/* <div className="index__container_mobile">
                    <IndexMob />
                </div> */}
                <div className="index__container">
                    <Header path="./index" />
                    <div className="main">
                        <Anchor id="time" />
                        <div className="main__container">
                            <div className="container-1">
                                <img
                                    alt="Время думать об искусстве"
                                    className="main__image"
                                    src={indexMobPng1}
                                />
                                <div className="title main__title">
                                    <div className="line">Время думать</div>
                                    <div className="line">об искусстве</div>
                                </div>
                                <div className="text">
                                    <div className="block">
                                        Одноклассники запустили просветительский проект «Время
                                        думать об искусстве», который привлекает внимание общества к
                                        людям с расстройствами аутистического спектра (РАС). Он
                                        состоит из нескольких частей: виртуальных подарков ОК,
                                        линейки брендированной одежды и информационной кампании в
                                        официальной группе центра «Антон тут рядом».
                                    </div>
                                    <div className="block">
                                        В создании визуальной составляющей проекта участвовали
                                        студенты центра, которые нарисовали авторские реплики
                                        известных картин Русского музея.
                                    </div>
                                </div>
                            </div>
                            <div className="container-2" style={{ position: 'relative' }}>
                                <Anchor id="gifts" />
                                <img
                                    alt="Делитесь Искусством!"
                                    className="main__image main__image_not-first"
                                    src={indexMobPng2}
                                />
                                <div className="title main__title">
                                    <div className="line">Делитесь</div>
                                    <div className="line">Искусством!</div>
                                </div>
                                <div className="text">
                                    <div className="block">
                                        На витрине подарков ОК появилась специальная секция с
                                        рисунками студентов Центра «Антон тут рядом». В ней собраны
                                        шедевры Малевича, Рериха, Штейнберга, Ларионова,
                                        Кандинского, Гончаровой, Розановой и других художников из
                                        коллекции Русского музея. Каждый подарок будет
                                        сопровождаться информационным баннером о жизни людей с
                                        аутизмом.
                                    </div>
                                    <div className="block">
                                        Пользователи ОК смогут бесплатно отправлять друг другу любой
                                        из этих подарков и таким образом помогать в распространении
                                        информации о жизни людей с аутизмом.
                                    </div>
                                </div>
                                <img
                                    alt=""
                                    className="main__image main__image_not-first"
                                    src={indexMobPng3}
                                />
                            </div>
                            <Button
                                href="https://ok.ru/gifts/charity"
                                rel="noopener noreferrer"
                                target="_blank"
                                text="страница подарков"
                            />
                        </div>
                    </div>

                    <Cards isOnMainPage />

                    <PhotoStory />

                    <div className="lamoda">
                        <Anchor id="lamoda" />
                        <div className="lamoda__hand" />
                        <div className="lamoda__tshirt" />
                        <div className="lamoda__content">
                            <div className="lamoda__limited" />
                            <div className="lamoda__text">
                                Линейка брендированной одежды с принтами — первая в истории ОК. Она
                                включает футболки и шопперы с авторскими репликами. «Красная
                                конница» К. Малевича и «Небесный бой» Н. Рериха, на сумках — «Голова
                                Крестьянина» К. Малевича и «Натюрморт» Э. Штейнберга. Купить
                                брендированную одежду можно в интернет-магазине Lamoda, официальном
                                партнере проекта. Средства от проданных футболок и шопперов пойдут
                                на работу центра «Антон тут рядом».
                            </div>
                            <Button
                                className="lamoda__button"
                                href="https://www.lamoda.ru/b/30712/brand-anton-tut-ryadom//"
                                rel="noopener noreferrer"
                                target="_blank"
                                text="перейти в магазин"
                            />
                        </div>
                    </div>
                    <div className="fund">
                        <Anchor id="fund" />
                        <div className="fund__button-wrapper">
                            <Button
                                className="fund__button"
                                href="https://antontut.ru"
                                isYellow
                                rel="noopener noreferrer"
                                target="_blank"
                                text="сайт фонда"
                            />
                        </div>
                        <div className="fund__container">
                            <img alt="" className="fund__image" src={fundPng} />
                            <div className="fund__title">Центр «Антон тут рядом»</div>
                            <div className="fund__description">
                                центр системной поддержки людей с аутизмом и их семей
                            </div>
                            <div className="fund__text">
                                С 2013 года Центр реализует программы помощи, направленные на
                                создание жизненного маршрута для человека с аутизмом в России: от
                                ранней диагностики и дошкольного инклюзивного образования до
                                сопровождаемого трудоустройства и самостоятельной жизни в обществе
                            </div>
                        </div>
                    </div>
                    <div className="live">
                        <Anchor id="live" />
                        <img alt="" className="emoji" src="./images/index/emoji-yellow.svg" />
                        <div className="title">Прямой эфир</div>
                        <div className="text">
                            Узнайте как студенты центра «Антон тут рядом» рисовали авторские реплики
                        </div>
                        <div className="live__video-wrapper">
                            <iframe
                                className="live__video"
                                src="https://ok.ru/videoembed/1884467896144"
                                title="Live video"
                            />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default Index;
